export default class AnonPaths {
  public static userLogin() {
    return '/'
  }

  public static userLoginChallenge() {
    return '/challenge'
  }

  public static featureFlags() {
    return '/feature-flags'
  }

  public static passwordRecovery() {
    return '/password-recovery'
  }

  public static tenantLogin() {
    return '/tenant/login'
  }

  public static resetPassword() {
    return '/new-password'
  }

  public static linkExpired() {
    return '/link-expired'
  }

  public static passwordExpired() {
    return '/password-expired'
  }

  public static passwordSetup() {
    return '/password-setup'
  }

  public static watchKudosTv(token: string) {
    return `/tv/watch/${token}`
  }

  public static maintenance() {
    return '/maintenance'
  }
}
